<template>
  <div class="interface">
    <!-- 导航栏 -->
    <div class="navigation">
      <div class="back" @click="Previouspage()"><<<</div>
      <img :src="logUrlList.home" class="home_img" @click="Maininterface()" />
    </div>
    <div class="subject">
      <div class="header"></div>
      <div class="main">
      <b-container >
      <b-row>
        <b-col cols="8" class="mx-auto">
              <div style="font-size: 20px; font-weight: 700; text-align: center;margin-top: 40px;">
            请填写您的信息
          </div>
        </b-col>
      </b-row>

      <div>
        <hr>
        <b-row class="rowItem">
          <b-col cols="3">
            <label for="input-name">姓名</label>
          </b-col>
          <b-col cols="9">
            <b-form-input v-model="name" id="input-name" type="text" placeholder="请输入办卡人姓名"  :state="nameError ? false : null"></b-form-input>
            <b-form-invalid-feedback v-if="nameError">{{
              nameErrorMessage
            }}</b-form-invalid-feedback>
            
          </b-col>
        </b-row>
        <hr>
        <b-row class="rowItem">
          <b-col cols="3">
            <label for="input-mobile">手机号</label>
          </b-col>
          <b-col cols="6">
            <b-form-input v-model="mobile" id="input-mobile" type="tel" maxlength="11" placeholder="请输入手机号"  :state="mobileError ? false : null"></b-form-input>
            <b-form-invalid-feedback v-if="mobileError">{{
              mobileErrorMessage
            }}</b-form-invalid-feedback>
          </b-col>
          <b-col cols="3">
            <!-- <b-button
              block
               variant="primary"
              style="font-size: 12px;"
              @click="getCore()"
              >验证码</b-button
            > -->
            <div class="verification" @click="getCore()">验证码</div>
            </b-col
          >
        </b-row>
        <hr>
        <b-row class="rowItem">
          <b-col cols="3">
            <label for="input-mobile">验证码</label>
          </b-col>
          <b-col cols="9">
            <b-form-input
              v-model="verificationCode"
              id="input-mobile"
              type="tel"
              maxlength="11"
              placeholder="请输入验证码"
               :state="verificationCodeError ? false : null"
            ></b-form-input>
            <b-form-invalid-feedback v-if="verificationCodeError">{{
              verificationCodeErrorMessage
            }}</b-form-invalid-feedback>
          </b-col>
        </b-row>
        <hr />
        <b-row class="rowItem">
          <b-col cols="3">
            <label>分行</label>
          </b-col>
          <b-col cols="9">
            <b-form-select v-model="bankCode" :options="options"></b-form-select>
          </b-col>
        </b-row>
        <hr>
        <b-row class="rowItem">
          <b-col cols="3">
            <label>网点</label>
          </b-col>
          <b-col cols="9">
            <b-form-select v-model="wangdian" :options="wangdian_options"></b-form-select>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col cols="1">
            <b-form-checkbox id="checkbox-1" v-model="status" name="checkbox-1" value="accepted" unchecked-value="not_accepted" />
          </b-col>
          <b-col style="font-size: 0.9rem;">
            我已阅读<font color="red" @click="showRules()">《**银行卡章程》</font>并同意相关内容。我授权**银行将本人申请信息提供给**银行个性化定制卡业务合作方。
          </b-col>
        </b-row>

        <b-row class="rowItemFee">
          <b-col cols="1">
          </b-col>
          <b-col style="font-size: 0.9rem;">
            下一步将由我行合作伙伴恒宝股份有限公司对图片进行处理及卡片费用结算。
          </b-col>
        </b-row>

        <b-row class="rowBtn">
          <b-col cols="10" class="mx-auto">
            <!-- <b-button block variant="danger" :disabled="disabled" @click="commitUserInfo()">下一步</b-button> -->
          <div class="nextstep"  @click="commitUserInfo()">下一步</div>
          </b-col>
        </b-row>
      </div>

      <b-modal ref="rules" ok-only scrollable title="******卡章程" ok-title="确定" centered>
        <div>
          <p>
            第一条 为规范黄山卡的发行和使用，更好地为持卡人提供服务，根据《银行卡业务管理办法》及中国银行业监督管理委员会、中国人民银行的相关规定，特制定本章程。
          </p>
          <p>
            第二条
            卡（以下简称黄山卡）是**银行发行的在中国境内及其他指定国家或地区使用的支付结算工具，具有消费结算、转账汇款、存取现金和投资理财等功能，可在**银行、特约单位和银联成员机构等联网终端上使用。黄山卡账户不得透支使用。
          </p>
          <p>
            第三条 黄山卡按介质类型分为磁条卡、纯芯片卡和磁条芯片复合卡（以下纯芯片卡和磁条芯片复合卡统称为芯片卡）。持卡人可在具备相应功能的设备上使用芯片卡进行交易。
          </p>

          <p>
            第四条 卡的申领条件
            <p class="innerText">凡自愿遵守本章程且符合发卡条件的个人，均可凭本人有效身份证件向发卡银行申请黄山卡。申请黄山卡须填写申请表，确认遵守《**银行黄山卡章程》。</p>
            <p class="innerText">凡注册于中国境内的企业法人和机关、事业单位、社会团体法人，可凭中国人民银行核发的开户许可证和指定申领人的有效身份证件等资料向发卡机构申领单位卡。申领单位可为其指定的持卡人申领若干张单位卡。</p>
          </p>
          <p>
            第五条
            黄山卡个人卡持卡人可凭卡和密码在**银行营业网点、特约单位、网上银行、电话银行、手机银行、及具备存款、取款、转账、汇款、查询、缴费、投资理财等功能的自动柜员机以及其他具备相应功能的设备上使用。持卡人通过电子银行办理业务时，应遵守**银行电子银行业务的相关规定。
          </p>
          <p>
            第六条 单位卡不得存取现金，只能在**银行指定单位的财务POS终端上办理查询与转账业务。
          </p>

          <p>
            第七条 申请黄山卡必须设定密码。凡使用密码进行的交易，**银行均视为持卡人本人所为。依据密码等电子信息办理的各类交易所产生的电子信息记录均为该项交易的有效凭据。
          </p>

          <p>
            第八条 持卡人须妥善保管黄山卡和密码。因持卡人保管不当而造成的损失，**银行不承担责任。
            <p class="innerText">若持卡人连续三次输入交易密码不正确，发卡银行将对黄山卡实施账户锁定。若持卡人仍记得密码的，需持黄山卡和本人有效身份证件到发卡银行营业网点办理解除锁定手续，发卡银行验证密码无误后解除账户锁定。</p>
            <p class="innerText">若持卡人遗忘密码，持卡人应凭黄山卡和本人有效身份证件，向发卡银行营业网点书面申请办理密码重置手续。</p>
          </p>
          <p>
            第九条 持卡人可持具备电子现金功能的芯片卡办理电子现金业务。芯片卡电子现金业务是指发卡银行根据持卡人要求将现金或账户存款转至芯片内存储，交易时直接从芯片内扣款的业务。芯片卡电子现金视同现金管理，不计息，不挂失。
            <p class="innerText">芯片卡电子现金交易不设交易密码，凡使用电子现金进行的交易均视为持卡人本人所为。持卡人因芯片卡保管不善造成的损失，发卡银行不承担责任。</p>
          </p>
          <p>
            第十条 持卡人遗失黄山卡应及时办理卡片挂失手续，卡片挂失分为口头挂失和正式挂失。口头挂失5天内，须补办正式挂失手续，否则口头挂失将自动失效。黄山卡电子现金不可挂失。
            <p class="innerText">挂失手续办妥，挂失即生效，挂失生效前持卡人因遗失黄山卡和密码产生的一切经济损失，银行不承担责任。</p>
          </p>
          <p>
            第十一条
            持卡人可持黄山卡个人卡办理本外币的活期、定期存款业务。黄山卡个人卡内存款（黄山卡电子现金除外）按照中国人民银行规定的相应存款利率及计息办法计付利息。黄山卡单位卡账户内的资金按照中国人民银行及我行相关规定的计息办法及利率计付利息。
          </p>
          <p>
            第十二条
            持卡人凭卡在自动柜员机上办理业务时，因机器故障或操作失误造成自动柜员机吞卡的，可在吞卡后3个工作日内（从吞卡次日算起）凭本人有效身份证件及其他可以证明该黄山卡为持有人的材料到自动柜员机所属银行网点办理领卡手续。逾期未领的，自动柜员机所属银行网点有权按规定程序处理。
          </p>
          <p>
            第十三条 黄山卡卡片损坏，持卡人应持本人有效身份证件和黄山卡，到**银行营业网点办理换卡手续。因芯片卡芯片损坏换卡的，电子现金余额以30天后脱机交易流水到账的结果为准，补发新卡需30天。
          </p>
          <p>
            第十四条 持卡人须按**银行规定缴纳相关费用。若持卡人未按规定缴纳费用，**银行有权中止提供相应服务。黄山卡收费项目和收费标准见**银行各营业网点及网站公布的公告。
          </p>
          <p>第十五条
            黄山卡卡片所有权属于**银行，持卡人拥有卡片使用权，不得出租和转借。委托他人代为办理业务的，须符合我行相关业务的代办规定。发卡银行有权根据相关法律法规、本章程规定以及相关协议约定停止持卡人使用黄山卡，并授权有关银行和特约单位收回黄山卡。</p>
          <p>第十六条 持卡人终止使用黄山卡，应持黄山卡向**银行营业网点提出书面销卡申请，**银行营业网点受理后，即可办理销卡手续。</p>
          <p>第十七条 为保障持卡人账户资金安全，**银行在发现持卡人存在被他人冒用等使用风险时，有权暂时对该账户停止支付。</p>
          <p>第十八条
            **银行通过电子银行、自动柜员机或营业网点向持卡人提供账务查询等对账服务。持卡人对交易账务有疑义的，应在交易发生日起60日内提出查询申请。**银行应当在30日内给予答复，并按国家有关法律规定对持卡人的资信资料保密。</p>
          <p>第十九条 **银行依法对持卡人的信息承担保密义务，未经当事人同意不得向任何单位和个人披露，但法律、法规和规章另有规定，或者与持卡人另有约定的除外。</p>
          <p>第二十条
            因供电、通讯、系统故障等不可抗力导致黄山卡暂时无法使用的，**银行将视情况协助持卡人解决问题或者提供必要的帮助，但不承担相关责任以及因此可能给持卡人造成的损失。对于在交易过程中，因暂时的网络通讯故障或其他原因造成的错账现象，银行将根据实际交易情况进行账务处理，以保障持卡人及银行双方的利益均不受损失。</p>
          <p>第二十一条 本章程由**银行制订、解释，并保留根据国家法律和规定修改本章程的权利。本章程修改或黄山卡收费项目、标准及利率等发生调整，一经公布即为有效，无须另行通知。持卡人可以选择继续使用或者销卡。</p>
          <p>第二十二条 本章程未尽事宜，按照国家有关法律、法规、规章执行。</p>
        </div>
      </b-modal>

      <b-modal ok-only ref="model_error" title="提示" @ok="handleOk" ok-title="确定" centered>
        <p>{{errorMsg}}</p>
      </b-modal>

      <b-modal ref="model_bank_confirm" title="提示" @ok="handleBankConfirm" ok-title="确定" cancel-title="取消" centered>
        <p>尊敬的客户，请确认您持有我行____数量！如您没有我行卡，可正常申请；
          如您持有超过__张（包含__张）卡，想继续申请此卡片，在领取卡片及办理激活前，需将您至少一张存量卡片先销户。</p>
      </b-modal>

      <b-modal ref="model_user_info" title="提示" @ok="handleUserInfo" content-class="shadow" ok-title="确定" cancel-title="取消" centered>
        <b-row>
          <b-col>
            _____申请信息如下，您是否申请卡片？
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col cols="4">
            申卡人：
          </b-col>
          <b-col cols="8">
            {{name}}
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col cols="4">
            手机号：
          </b-col>
          <b-col cols="8">
            {{mobile}}
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col cols="4">
            领卡网点：
          </b-col>
          <b-col cols="8" class="itemWordWrap">
            {{address}}
          </b-col>
        </b-row>
      </b-modal>
      <!-- 验证码弹窗 -->
   <b-modal
        ok-only
        ref="mobile_error"
        title="提示"
        @ok="handleOk"
        ok-title="确定"
      >
        <p>{{ mobileErrorInfo }}</p>
      </b-modal>
      <!-- loading toast -->
      <div v-show="loading">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast">
          <i class="weui-loading weui-icon_toast"></i>
          <p class="weui-toast__content">提交中</p>
        </div>
      </div>

      <div v-show="showToast">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast">
          <p class="weui-toast__content">{{toastMsg}}</p>
        </div>
      </div>
    </b-container>

      </div>
      <div class="footer"></div>
    </div>
  </div>
</template>
<script>
const logUrl = require("@/common/logUrl.js");
import axios from 'axios'
const config = require('@/common/config.js')
import { mobile_pattern , generateRandomNumericString} from "@/js/verifyData"
export default {
  name: "InformationFilling",
  data() {
    return {
      logUrlList: logUrl.logUrl,
      status: 'not_accepted',
        disabled: true,
        name: '',
        mobile: '',
        bankCode: null,
        address: null,
        wangdian: null,
        options: [{
          value: null,
          text: '请选择分行'
        }],
        wangdian_options: [{
          value: null,
          text: '请选择领卡网点'
        }],
        errorMsg: '',
        loading: false,
        showToast: false,
        toastMsg: '',
        verificationCode: "", //验证码
        mobileError: false,
        mobileErrorMessage: "手机号码格式不正确",
        mobileErrorInfo: "", //弹窗显示
        nameError: false,
        nameErrorMessage: "请输入正确的姓名",
        nameErrorInfo: '',
        verificationCodeError: false,
        verificationCodeErrorMessage: "请输入正确的验证码",
        verificationCodeErrorInfo: '',
        
    };
  },
  methods: {
    Previouspage() {
      this.$router.push({
          name: 'HomePage',
      })
    },
    Maininterface() {
       this.$router.push({
          name: 'HomePage',
        })
     },
      showToastMsg: function(msg) {
        this.toastMsg = msg
        let that = this
        that.showToast = true
        setTimeout(function() {
          that.showToast = false
        }, 2000)
      },
      showLoading: function() {
        this.loading = true
      },
      hideLoading: function() {
        this.loading = false
      },
      handleUserInfo: function() {
        this.getBankSn()
      },
      showUserInfo: function() {
        this.$refs['model_user_info'].show()
      },
      handleBankConfirm: function() {
        this.showUserInfo()
      },
      showBankConfirm: function() {
        this.$refs['model_bank_confirm'].show()
      },
      handleOk: function(bvModalEvt) {
      },
      showErrorMsg: function() {
        this.$refs['model_error'].show()
      },
        mobileErrorMsg: function() {
      this.$refs["mobile_error"].show();
    },
      // 获取验证码
    getCore() {
      let param = this.mobile;
      if (this.mobile == "") {
        this.mobileErrorInfo = "请输入手机号码";
        this.mobileErrorMsg();
      } else if (!this.mobileError) {
        axios.get(config.config_hs.getCore + param).then(res => {
          console.log("res-->", res);
          let data = res.data;
          if (data.code == 200) {
            // 验证码获取成功
          } else if (data.code == 500) {
            this.mobileErrorInfo = data.message;
            this.mobileErrorMsg();
          }
        });
      }
      },
     // 验证验证码
    getVerificationCode() {
      let param = this.mobile + "/" + this.verificationCode;
      axios.get(config.config_hs.verifyCore + param).then(res => {
        console.log("res--->", res);
        let data = res.data;
        if (data.code == 200) {
          // 验证码验证成功
          this.showBankConfirm();
        } else if (data.code == 500) {
          this.mobileErrorInfo = data.message;
          this.mobileErrorMsg();
        }
      });
    },
      getWangdian: function(bankCode) {
        var that = this
        let params = {
            bankCode:config.config_hs.bankCode,
            ascriptionCode: this.bankCode
          }
        axios.post(config.config_hs.getBranchInfoNewByParam, params).then(function(response) {
          let data = response.data
            var wandianInfos = new Array(data.length + 1)
            var obj = new Object()
            obj.value = null
            obj.text = '请选择领卡网点'
            wandianInfos[0] = obj
            // {bankSubCode: "0051_11", branchAddress: "拉萨扩大飞机啊到了", branchName: "阿拉山口放假啊", branchNumber: "01", id: 1}
            for (let i = 0; i < data.length; i++) {
              let item = data[i]
              let info = new Object()
              info.value = item.branch_code
              info.text = item.branch_name
              wandianInfos[i + 1] = info
            }
            that.wangdian_options = wandianInfos
            console.log("wangdian_options--->",that.wangdian_options)
        })
      },
      queryBankInfo: function() {
        var that = this
        axios.get(config.config_hs.queryBankBranchList, {
          params: {
            bankCode: config.config_hs.bankCode
          }
        }).then(function(response) {
          console.log(response)
          let dataRes = response.data
          if (dataRes.code != 0) {
            that.showToastMsg(dataRes.message)
            return
          }
          let data = dataRes.bankSubList
          var bankInfos = new Array(data.length + 1)
          var obj = new Object()
          obj.value = null
          obj.text = '请选择分行'
          bankInfos[0] = obj
          for (let i = 0; i < data.length; i++) {
            let item = data[i]
            let info = new Object()
            info.value = item.branchCode
            info.text = item.branchName
            bankInfos[i + 1] = info
          }
          that.options = bankInfos
          console.log("options ---->", that.options)
        }).catch(function(error) {
          console.log(error)
        })
      },
      getBankSn: function () {
        let randomNumericString  = generateRandomNumericString(6) 
        sessionStorage.setItem('userId', randomNumericString);
        var that = this
        let finalBankCode = this.bankCode + '_' + this.wangdian
        let param = {
          clientName: this.name,
          clientPhoneNumber: this.mobile,
          bankCode: config.config_hs.bankCode,
          bankSubCode: this.bankCode, //分行编码
          bankBranchCode: this.wangdian, //支行|网点编码 "01"
          bankSerialNumber: "", //银行唯一号
          address: this.address
        }
        console.log("param--->",param)
        that.showLoading()
        axios.post(config.config_demo.submitUserInfo, param)
          .then(function(response) {
            // {code: 0, message: "交易成功", backSerialNumber: "2d506a29aaf846d3947ce1acfa9b38ad"}
            that.hideLoading()
            var data = response.data
            if (data.code == 0) {
              that.toSelectCardFace(data.backSerialNumber, data.bankCode)
            } else {
              console.log('提交用户信息失败：' + data.message)
              that.errorMsg = data.message
              that.showErrorMsg()
            }
          })
          .catch(function(error) {
            that.hideLoading()
            console.log(error)
          })
      },
      commitUserInfo: function() {
        const pattMobile = mobile_pattern
        if (this.name.length == 0 || this.name.length < 2 || this.name.length > 15) {
          this.showToastMsg('您输入的姓名长度不符合要求，请重新输入')
          return
        }

        if (!pattMobile.test(this.mobile)) {
          this.showToastMsg('请输入正确的手机号')
          return
        }

         if (this.verificationCode == "") {
        this.showToastMsg("请输入验证码");
        return;
      }
        if (this.bankCode == null) {
          this.showToastMsg('请选择分行')
          return
        }

        if (this.wangdian == null) {
          this.showToastMsg('请选择领卡网点')
          return
        }
        // 验证码的正确性
        this.getVerificationCode();
        // this.showBankConfirm()
        // this.toSelectCardFace();
      },
    toSelectCardFace: function (bankSerialNumber, bankCode) {
        localStorage.setItem('phone', this.mobile);
        localStorage.setItem('bankSerialNumber', bankSerialNumber);
        this.$router.replace({
          name: 'SelectBusinessProcess',
          params: {
            bankCode: bankCode,
            phone:this.mobile
          }
        })
      },
      showRules: function() {
        this.$refs['rules'].show()
      },
       validateMobile(mobile) {
      // 使用正则表达式验证手机号码
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(mobile)) {
        this.mobileError = true;
      } else {
        this.mobileError = false;
      }
    },
    validateName(name) {
      const nameRegex = /^([\u4e00-\u9fa5]{2,15}|[A-Za-z\s'-]+)$/u;
      if (!nameRegex.test(name)) {
        this.nameError = true;
      } else {
        this.nameError = false;
      }
    },
    validateVerificationCode(verificationCode) {
      const verificationCodeRegex = /^\d{6}$/;
      if (!verificationCodeRegex.test(verificationCode)) {
        this.verificationCodeError = true;
      } else {
        this.verificationCodeError = false;
      }
    }
    },
  watch: {
      mobile(newVal, oldval) {
      this.validateMobile(newVal);
      },
      name(newVal, oldval) {
      this.validateName(newVal)
      },
      verificationCode(newVal, oldval) {
      this.validateVerificationCode(newVal)
      },
      status: function(newval, oldval) {
        console.log('newval：' + newval, 'oldval：' + oldval)
        if (newval == 'accepted') {
          this.disabled = false
        } else {
          this.disabled = true
        }
      },
      wangdian: function(newval, oldval) {
        let that = this
        console.log('wangdian newval:' + newval + ',' + 'wangdian oldval:' + oldval)
        if (newval == null) {
          this.address = null
          return
        }
        for (let i = 0; i < this.wangdian_options.length; i++) {
          var item = this.wangdian_options[i]
          console.log(item.value)
          console.log(item.text)
          if (item.value == newval) {
            that.address = item.text
            break
          }
        }
      },
      bankCode: function(newval, oldval) {
        console.log('newval:' + newval + ',' + 'oldval:' + oldval)
        this.wangdian = null
        if (newval == null) {
          this.wangdian_options = [{
            value: null,
            text: '请选择领卡网点'
          }]
          return
        }

        for (let i = 0; i < this.options.length; i++) {
          let item = this.options[i]
          if (item.value == newval) {
            this.getWangdian(newval)
            break
          }
        }
      }
  },
  mounted() {
    const userAgent = navigator.userAgent.toLowerCase();  
      console.log("userAgent--->",userAgent)
    this.queryBankInfo()
  
    },
};
</script>

<style scoped>
.navigation {
  position: fixed;
  z-index: 1000;
  width: 100%;
  background: linear-gradient(left, #3861d5, white);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 2rem;
}
.home_img {
  width: 1.8rem;
}
.back {
  font-size: 1.2rem;
  font-weight: 700;
  color: white;
}
/* 页面主体内容 */
/* .subject {
  padding: 1.8rem 1.8rem 0;
  background-color: pink;
  display: flex;
  flex-direction: column;
  justify-content: center;
} */
/* .header {
  background-color: aqua;
  height: 3rem;
} */
/* .main {
  background-color: yellow;
  height: 3rem;
} */
/* .footer {
  background-color: blue;
  height: 3rem;
} */
 .verification{
  color: white;
  background-color: #3861d5;
  text-align: center;
  border-radius: 1rem;
  width: 4rem;
 }
 .nextstep{
  color: white;
  background-color: #3861d5;
  display: flex;          /* 启用 Flex 布局 */
  align-items: center;    /* 垂直居中 */
  justify-content: center;
  font-size: 1rem;
  border-radius: 1.5rem;
  width: 100%;
  height: 3rem;
 }
   .rowItem {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .rowItemFee {
    margin-top: 1rem;
  }

  .rowBtn {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }

  .page {
    margin-top: 4vh;
  }

  .img {
    width: 100%;
  }

  .innerText {
    text-indent: 2rem;
  }

  .itemWordWrap {
    word-wrap: break-word;
  }
</style>



// WEBPACK FOOTER //
// src/components/DIYApplyCardSurface/ApplicationCard/InformationFilling.vue